import i18n from "../plugins/i18n";

const t = i18n.t.bind(i18n);
const tc = i18n.tc.bind(i18n);

export const inputRules = {
  required: [
    (v) => {
      return !!v || t("inputIsRequiredMessage");
    },
  ],
  email: [
    (v) => !!v || t("emailIsRequiredMsg"),
    (v) =>
      !v ||
      /^[a-zA-Z0-9\.!#$%&'*+/=?^_~-]+@([a-zA-Z0-9]+\.)+[a-zA-Z]{2,3}$/.test(
        v
      ) ||
      t("emailMustBeValidMsg"),
    (v) => !v || (v && v.length <= 50) || tc("maximumCharsMsg", { count: 50 }),
  ],
  password: [
    (v) => !!v || t("passwordIsRequiredMsg"),
    (v) => (v && v.length >= 8) || t("minimumCharsMsg", { count: 8 }),
    (v) =>
      /(?=.*[A-Z])/.test(v) || t("mustHaveAtLeastOneUppercaseCharacterMsg"),
    (v) => /(?=.*\d)/.test(v) || t("mustHaveAtLeastOneNumberMsg"),
    (v) => /([!@$%.])/.test(v) || t("mustHaveAtLeastOneSpecialCharacterMsg"),
  ],
};
